import React, { Component } from 'react';
import { toastr } from 'react-redux-toastr';
import api from '../../api';
import CONSTS from '../../config/consts';
import Requisition from '../../utils/requisitions/requisition';
import Language from '../../config/language';
import { connect } from 'react-redux';
import LoadingPage from '../../common/template/loadingPage';
import ErrorPage from '../../common/template/errorPage';
import Pagination from '../../common/template/pagination';
import EmptyList from '../../common/template/emptyList';
import { urlParamsConverter } from '../../config/methods';

const QUERY_INIT = { page: 1 };

class List extends Component {
  constructor(props){
    super(props);

    this.state = {
      loaded: false,
      list: [],
      pageActive: 1,
      query: {...QUERY_INIT, ...props.query},
      errorLoadingPage: false,
      pagination: CONSTS.PAGINATE
    };
    this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    this.loadPage(this.state.pageActive);
  }

  componentWillReceiveProps(nextProps) {
    //existe uma nova query vinda de uma busca
    if (JSON.stringify(nextProps.query) !== JSON.stringify(this.props.query)) {
      this.setState({query: nextProps.query, loaded: false}, () => this.loadPage());
    }
  }

  loadPage(page){
    const token = this.props.user;
    const self = this;
    const query = `?${urlParamsConverter(this.state.query)}`;

    Requisition({
      header: {
        [CONSTS.API_KEY ]: CONSTS.API_KEY_VALUE,
        'Auth' : 'Bearer '+token
      },
      type: 'get',
      url: `${api.API_URL}${api.API.vendas.list}${query}`,
      success: response => {
        const data = response.data;
        if(data){
          self.loaded();

          if(data.status){
            self.setState({
              list: data.data,
              pagination: data.pagination
            });
          }else{
            toastr.warning(Language.atencao, data.msg);
            self.setErrorLoadingPage();
          }
        }else{
          toastr.error(Language.erroTitle, Language.erro01);
          self.setErrorLoadingPage();
        }
      },
      error: response => {
        toastr.error(Language.erroTitle, Language.erro02);
        self.loaded();
        self.setErrorLoadingPage();
      }
    });
  }

  changePage(goTo){
    const page = goTo==='next' ? this.state.pagination.next : this.state.pagination.prev;

    this.setState({
      query: {...this.state.query, page}
    }, () => this.loadPage());
  }

  setErrorLoadingPage(){
    this.setState({
      errorLoadingPage: true
    });
  }

  loaded(){
    this.setState({
      loaded: true
    });
  }

  renderRows() {
      const list = this.state.list || [];

      return list.map(bc => {
        let status = bc.status;

        switch (Number(status.id)) {
          case 1:
            status = <span className='label label-primary'>{bc.status.status}</span>;
            break;
          case 2:
            status = <span className='label label-danger'>{bc.status.status}</span>;
            break;
          case 3:
            status = <span className='label label-warning'>{bc.status.status}</span>;
            break;
          case 4:
            status = <span className='label label-info'>{bc.status.status}</span>;
            break;
          default:
            status='';
        }

        return (
          <tr key={bc.id}>
            <td>{bc.id}{`${bc.id_integracao ? "("+bc.id_integracao+")" : ''}`}</td>
            <td>{`${bc.cliente.nome} ${bc.cliente.sobrenome ? bc.cliente.sobrenome : ''}`}</td>
            <td>{bc.data}</td>
            <td>
              {`${bc.total ? bc.total.formated : ""}`}
            </td>
            <td>
              {
                <span className={`${String(bc.finalizado) === "1" ? 'label label-info' : 'label label-default'}`}>{bc.finalizado ? "Finalizado" : "Em aberto"}</span>
              }
            </td>
            <td>
              {
                status
              }
            </td>
            <td>
              {
                <span className={`${bc.completo === 1 ? 'label label-warning' : 'label label-danger'}`}>{bc.completo ? "Sim" : "Não"}</span>
              }
            </td>

            <td>
                <button className='btn btn-warning' onClick={() => this.props.showUpdate(bc)}>
                    <i className='fa fa-pencil'></i>
                </button>
                <button className='btn btn-danger' onClick={() => this.props.showDelete(bc)}>
                    <i className='fa fa-trash-o'></i>
                </button>
            </td>
          </tr>
        );
      })
  }

  renderTable(){
    return (
      <div>
        {
          this.state.list.length ?
            <div>
              <table className='table'>
                  <thead>
                      <tr>
                          <th>ID</th>
                          <th>Cliente</th>
                          <th>Data</th>
                          <th>Valor</th>
                          <th>Venda</th>
                          <th>Status</th>
                          <th>Sessões finalizadas</th>
                          <th className='table-actions'></th>
                      </tr>
                  </thead>
                  <tbody>
                      {this.renderRows()}
                  </tbody>
              </table>
              <Pagination onClick={this.changePage} dados={this.state.pagination} />
            </div>
          : <EmptyList />
        }
      </div>
    );
  }

  render() {
      const tempBox = this.state.loaded
      ? (this.state.errorLoadingPage ? <ErrorPage /> : this.renderTable())
      : <LoadingPage />;
      return (
          <div>
            {
              tempBox
            }
          </div>
      )
  }
}

const mapStateToProps = store => ({
  user: store.auth.user
});

export default connect(mapStateToProps)(List);
